import { chunk, uniqBy } from 'lodash';
import GenerateRequest from './resources';
import _ from 'lodash';
import { checkLicenseExpiry } from './ResourceValidations';

const req = GenerateRequest();

export default {
  async getVendors(params) {
    try {
      await checkLicenseExpiry();
      let totalCount = 0;
      let completeData = [];
      if (params.category && params.category.length > 200) {
        const categoryChunks = chunk(params.category, 200);
        for (const categoryChunk of categoryChunks) {
          params.category = categoryChunk;
          const tempData = await req.get('vendors', { params });
          if (!_.isEmpty(tempData.data)) {
            completeData.push(...tempData.data.data);
          }
        }
      } else {
        const tempData = await req.get('vendors', { params });
        if (!_.isEmpty(tempData.data)) {
          completeData.push(...tempData.data.data);
        }
        totalCount = tempData.data.total;
      }
      const sortedVendors = { data: uniqBy(completeData, '_id') };
      if (totalCount) {
        sortedVendors.total = totalCount || 0;
      }
      return sortedVendors;
    } catch (e) {
      console.log(e);
      throw e;
    }
  },
  async addVendor(params) {
    try {
      await checkLicenseExpiry();
      const { data: newVendor } = await req.post('vendors/add', params);
      return newVendor;
    } catch (error) {
      console.error(`Error: ${error.message}`);
      throw error;
    }
  },
  async updateVendor(params) {
    try {
      await checkLicenseExpiry();
      const updatedVendor = await req.post(`vendors/edit/${params._id}`, params);
      return updatedVendor;
    } catch (error) {
      console.error(`Error: ${error.message}`);
      throw error;
    }
  },
  async archive(params) {
    try {
      await checkLicenseExpiry();
      const { data: archivedvendors } = await req.post('vendors/archive', params);
      return archivedvendors;
    } catch (error) {
      console.error(`Error: ${error.message}`);
      throw error;
    }
  },
  async unarchive(params) {
    try {
      await checkLicenseExpiry();
      const { data: unarchivedVendor } = await req.post('vendors/unarchive', { params });
      return unarchivedVendor;
    } catch (error) {
      console.error(`Error: ${error.message}`);
      throw error;
    }
  },
  async getCategories(params) {
    try {
      await checkLicenseExpiry();
      const { data: categories } = await req.get('categories', { params });
      return categories;
    } catch (error) {
      console.error(`Error: ${error.message}`);
      throw error;
    }
  },
  async getSubCategories(params) {
    try {
      await checkLicenseExpiry();
      const { data: subCategories } = await req.get('categories/subCategories', { params });
      return subCategories;
    } catch (error) {
      console.error(`Error: ${error.message}`);
      throw error;
    }
  },
  async addCategories(params) {
    try {
      await checkLicenseExpiry();
      const { data: newCategory } = await req.post('categories/add', params);
      return newCategory;
    } catch (error) {
      console.error(`Error: ${error.message}`);
      throw error;
    }
  },
  async updateCategories(params) {
    try {
      await checkLicenseExpiry();
      const updatedCategory = await req.post(`categories/edit/${params._id}`, params);
      return updatedCategory;
    } catch (error) {
      console.error(`Error: ${error.message}`);
      throw error;
    }
  },
  async archiveCategory(params) {
    try {
      await checkLicenseExpiry();
      const { data: archivedCategory } = await req.post('categories/archive', params);
      return archivedCategory;
    } catch (error) {
      console.error(`Error: ${error.message}`);
      throw error;
    }
  },
};
